import { defineStore } from "pinia";
import { useAuthStore } from "./auth";
import { getPredictionsApiUtils } from "../utils/predictionsApiUtils";

export const useFiltersStore = defineStore("filters", {
  state: () => ({
    set: false,
    selection: {
      league: null,
      guild: null,
      numberOfGames: null,
      theme: "dark",
      startDate: null,
      endDate: null,
    },
    data: {
      leagues: [],
      guilds: [],
      numberOfGames: [{"value": 1},{"value": 2},{"value": 3},{"value": 4},{"value": 5},{"value": 6},{"value": 7},{"value": 8},{"value": 9},{"value": 10}],
      themes: [{"name": "light", "display": "Light mode"},{"name": "dark", "display": "Dark mode"}],
    }
  }),
  actions: {
    async setAllFilters() {
      const auth = useAuthStore();
      if (auth.loggedIn) {
        await this.updateLeagues();
        await this.updateGuilds();
        await this.updatePreferredSelections();
        this.set = true;
      }
    },
    async updatePreferredSelections() {
      const auth = useAuthStore();
      if (auth.loggedIn) {
        this.selection.league = auth.userData.preferredLeague || this.data.leagues[0].id;
        this.selection.guild = auth.userData.preferredGuild || this.data.guilds[0].discord_id;
        this.selection.numberOfGames = auth.userData.preferredNumberOfGames || 6;
        this.selection.theme = auth.userData.preferredTheme || "dark";
        document.body.setAttribute("data-bs-theme", this.selection.theme);
      }
    },
    async updateLeagues() {
      this.data.leagues = await getPredictionsApiUtils().getLeagues();
    },
    async updateGuilds() {
      const auth = useAuthStore();
      if (auth.loggedIn) {
        this.data.guilds = auth.userGuilds;
      }
    },
    toggleTheme() {
      this.selection.theme = this.selection.theme == "dark" ? "light" : "dark";
      document.body.setAttribute("data-bs-theme", this.selection.theme);
    },
    getFiltersForUpdate() {
      return {
        "preferredLeague": this.selection.league,
        "preferredGuild": this.selection.guild,
        "preferredNumberOfGames": this.selection.numberOfGames,
        "preferredTheme": this.selection.theme,
      }
    }
  }
});